@if (spinner) {
  <app-spinner></app-spinner>
}

<div class="inner-page-header">
  <h3>
    ارجاع مبلغ
    @if (order) {
      <a class="header-link" (click)="goOrder()">طلب #{{order?.reference_number}}</a>
    }
  </h3>
</div>

@if (order) {
  <form [formGroup]="refundFormGroup">
    <div class="main-card">
      <div class="row">
        <div class="col-md-6">
          <app-switch-input
            [label]="'تحويل حالة الطلب الى ملغي'"
            [labelEn] = "'changeOrderStatusToCancel'"
            [value]="changeOrderStatus"
            (valueChanged) = "changeOrderStatusHandler($event)">
          </app-switch-input>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="" class="form-label">رقم الطلب الاساسي </label>
            <input type="text" class="form-control" readonly formControlName="orderNumber" />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="" class="form-label">
              نوع الإرجاع
            </label>
            <ng-select bindLabel="name" class="single-select" placeholder="يرجى اختيار نوع الإرجاع " appendTo="body"
              [searchable]="true" formControlName="refundType" (change)="TypeChanged($event)" [clearable]="true">
              @for (type of refundTypes; track type) {
                <ng-option [value]="type.id">
                  {{type.name}}
                </ng-option>
              }
            </ng-select>
          </div>
        </div>
        @if (showValueField) {
          <div class="col-6">
            <div class="form-group">
              <label for="" class="form-label">مبلغ الإرجاع للعميل شامل الضريبة</label>
              <span class="static-code">{{valueMark}}</span>
              <input type="number" class="form-control" formControlName="value" />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="" class="form-label"> حصة الفاحص بعد الإرجاع</label>
              <span class="static-code">{{valueMark}}</span>
              <input type="number" class="form-control" formControlName="inspector_share_after_refund" />
            </div>
          </div>
        }
        <div class="col-6">
          <div class="form-group">
            <label for="" class="form-label">
              طريقة الدفع
            </label>
            <ng-select bindLabel="name" class="single-select" placeholder="يرجى اختيار طريقة الدفع " appendTo="body"
              [searchable]="true" formControlName="paymentMethod" [clearable]="true">
              @for (method of paymentMethods; track method) {
                <ng-option [value]="method.id">
                  {{method.name}}
                </ng-option>
              }
            </ng-select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="" class="form-label">سبب الارجاع</label>
            <ng-select bindLabel="name" class="single-select" placeholder=" اختر من القائمة " appendTo="body"
              formControlName="refundReason" [clearable]="true">
              @for (reason of refundReasons; track reason) {
                <ng-option [value]="reason.id">
                  {{reason.name}}
                </ng-option>
              }
            </ng-select>
          </div>
        </div>
      </div>

      @if (showRefundView) {
      <div class="req-refund">
        <div class="req-row">
          <div class="req-full-box">
            <div class="req-data"> المبلغ المدفوع </div>
            <div class="req-title">{{final_cost}}<span> ر.س </span></div>
          </div>
          @if (inspector_fees || payment_fee) {
          <div class="req-full-box">
            <div class="req-data"> خصم الرسوم الإدارية </div>
            <span> - </span>
            <div class="req-title">{{payment_fee}}<span> ر.س </span></div>
          </div>
          }
          @if (inspector_fees) {
          <div class="req-full-box">
            <div class="req-data"> خصم رسوم زيارة الفاحص </div>
            <span> - </span>
            <div class="req-title"> {{inspector_fees}}<span> ر.س </span></div>
          </div>
          }
          @if (tax) {
            <div class="req-full-box">
              <div class="req-data"> ضريبة القيمة المضافة </div>
              <span> - </span>
              <div class="req-title"> {{tax}}<span> ر.س </span></div>
            </div>
          }
          <div class="req-full-box total-refund">
            <div class="req-data"> إجمالي مبلغ الإرجاع </div>
            <div class="req-title">{{remain_cost}}<span> ر.س </span></div>
          </div>
        </div>
      </div>
      }
   
      <div class="row">
        <div class="col-12">
          @if (alertmsg) {
            <div class="alert-box">
              <img alt=""
                src="assets/images/svg/error-icon.svg"
                class="close-alert"
                (click)="hideErrorMSG()"
                alt=""
                />
                <p class="alert-msg">{{errorMessage}}</p>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col-md-12 double-action">
          <button class="btn btn-cancel" (click)="goOrder()" type="button">
            رجوع
          </button>
          <app-action-button (submitAction)="save($event)"></app-action-button>
        </div>
      </div>
    </form>
  }
